export const RECIPE_MODELS = [
    { id: 'openrouter:anthropic/claude-fable-5', label: 'Claude Fable 5' },
    { id: 'openrouter:anthropic/claude-opus-5', label: 'Claude Opus 5' },
    { id: 'openrouter:anthropic/claude-opus-4-8', label: 'Claude Opus 4.8' },
    { id: 'openrouter:anthropic/claude-sonnet-5', label: 'Claude Sonnet 5' },
    { id: 'openrouter:x-ai/grok-4.20', label: 'Grok 4.20' },
    { id: 'openrouter:google/gemini-3.6-flash', label: 'Gemini 3.6 Flash' },
    { id: 'openrouter:z-ai/glm-5.2', label: 'GLM 5.2' },
];
export const RECIPE_MODEL_IDS = RECIPE_MODELS.map((m) => m.id);
/** Is this id one a household may select? The API refuses to store anything else. */
export function isRecipeModel(id) {
    return RECIPE_MODEL_IDS.includes(id);
}
/** The label for a known id, or the raw id (e.g. an Ollama default not in the list). */
export function recipeModelLabel(id) {
    return RECIPE_MODELS.find((m) => m.id === id)?.label ?? id;
}
//# sourceMappingURL=models.js.map